<template>
  <v-dialog v-model="dialog" max-width="500px">
    <v-card>
      <v-card-title>
        Produtos e setores disponíveis para validação
      </v-card-title>
      <v-container fluid>
        <v-checkbox
          color="primary"
          :label="`Todos os setores`"
          v-model="selectedAll"
          @click.native.stop="selectedAll != selectedAll"
        ></v-checkbox>
        <template v-for="(product, index) in products">
          <v-checkbox
            :label="`${product.name} - ${product.typeName}`"
            color="info"
            :key="index"
            v-model="product.enabled"
            @click.native.stop="toggleProduct(product)"
          ></v-checkbox>
        </template>
      </v-container>
      <v-card-actions>
        <v-btn color="primary" outline @click.stop="fetchProducts">Atualizar</v-btn>
        <v-spacer />
        <v-btn color="primary" flat @click.stop="dialog = false">Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  computed: {
    products: {
      get() {
        return this.$store.getters.products
      }
    },
    selectedAll: {
      get() {
        return (
          this.$store.getters.products.length === this.$store.getters.products.filter(product => product.enabled).length
        )
      },
      set(value) {
        this.toggleAll(value)
      }
    },
    selectedEvent() {
      return this.$store.getters.selectedEvent
    },
    dialog: {
      get() {
        return this.$store.getters.productsConfigDialog
      },
      set(value) {
        if (!value) {
          this.$store.dispatch('closeProductsConfigDialog')
        }
      }
    }
  },
  methods: {
    toggleAll(value) {
      this.$store.dispatch('toggleAllProductsValidation', value)
    },
    toggleProduct(product) {
      this.$store.dispatch('toggleProductValidation', product)
    },
    fetchProducts() {
      this.$store.dispatch('setProductsList', this.selectedEvent.id)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/configs/ProductsConfig.vue